import React, { Component } from 'react';
import { ActionIDs } from "../../../GenericWebController/ActionGraph/ActionIDs/ActionIDs"
import Actions from "../../../GenericWebController/ActionGraph/Actions"
import { DebugAlert, Class, Interface, Abstract, ObjectTypes, JSTypeOperator, cListForBase } from "../../../GenericCoreGraph/ClassFramework/Class"
import TObject from "../../../TagComponents/TObject"
import GenericWebGraph from "../../../GenericWebController/GenericWebGraph"
import { CommandInterfaces } from "../../../GenericWebController/CommandInterpreter/cCommandInterpreter"
import { CommandIDs } from "../../../GenericWebController/CommandInterpreter/CommandIDs/CommandIDs"

import { withStyles } from '@material-ui/core/styles';
import BigCalendarStyles from "../../../../ScriptStyles/BigCalendarStyles"
import classNames from "classnames"
import moment from "moment";



var TBigCalenderDayHeader = Class( TObject,

  {
    ObjectType: ObjectTypes.Get( "TBigCalenderDayHeader" )
    ,
    constructor: function ( _Props )
    {
      TBigCalenderDayHeader.BaseObject.constructor.call( this, _Props );
      this.state =
      {
        ...this.state
      }
    }
    ,
    Destroy: function ()
    {
      TBigCalenderDayHeader.BaseObject.Destroy.call( this );
    }
    ,
    HandleGetBoxProps: function ()
    {
      const { classes } = this.props;
      if (this.props.type == window.Enums.EBigCalenderType.MiniAvailableTimeShow)
      {
        if (this.props.first)
        {
          return classes.miniHeaderDayFirst;
        }
        else
        {
          return classes.miniHeaderDay;
        }
      }
      return classes.headerDay;
    }
    ,
    render: function ()
    {
      if (!this.props.daydate)
      {
        return <div className={classNames(this.HandleGetBoxProps())}></div>
      }
      const { classes } = this.props;
      //var __DayList = moment().day(0);

      var __DayNamePart1 = moment(this.props.daydate).locale(this.state.Language.LanguageCode).format("MMM");
      var __DayNamePart2 = moment(this.props.daydate).locale(this.state.Language.LanguageCode).format("D");
      var __DayNamePart3 = moment(this.props.daydate).locale(this.state.Language.LanguageCode).format("dd");
      var __DayNamePart4 = moment(this.props.daydate).locale(this.state.Language.LanguageCode).format("ddd");

      /*if (this.props.type == window.Enums.EBigCalenderType.AvailableTimeSelection || this.props.type == window.Enums.EBigCalenderType.ClassTimeSelection)
      {
        __DayName = moment(this.props.daydate).locale(this.state.Language.LanguageCode).format("ddd");
      }
      else if (this.props.type == window.Enums.EBigCalenderType.MiniAvailableTimeShow)
      {
        __DayName = moment(this.props.daydate).locale(this.state.Language.LanguageCode).format("Do dd");
      }*/

      //var __DayNumber = this.props.daydate.getDay();
      //var __DayName = moment().isoWeekday(__DayNumber);
      //var __DayOfMounth = this.props.daydate.getDate().toString();
      if (this.props.type == window.Enums.EBigCalenderType.AvailableTimeSelection || this.props.type == window.Enums.EBigCalenderType.ClassTimeSelection)
      {
        if (this.props.mobileSize ){
          return (
            <div className={classNames(this.HandleGetBoxProps())} style={{ fontSize: "13px", fontWeight: 500 }}>{__DayNamePart4}</div>
          )
        }
        else
        {
          return (
            <div className={classNames(this.HandleGetBoxProps())} style={{ fontWeight: 500 }}>{__DayNamePart4}</div>
          );
        }

      }
      else if (this.props.type == window.Enums.EBigCalenderType.MiniAvailableTimeShow)
      {
          return (
            <div className={classNames(this.HandleGetBoxProps())} style={{ fontWeight: 500 }}>
              {__DayNamePart2}
              <br/>
              {__DayNamePart3}
            </div>
          );
      }
      else
      {
        if (this.props.type === window.Enums.EBigCalenderType.SellerBookedScheduler && this.props.mobileSize){
          return (
            <div style={{ fontSize: "12px", fontWeight: 500 }} className={classNames(this.HandleGetBoxProps())}>
              {__DayNamePart1 + " " + __DayNamePart2}
            </div>
          )
        }
        else if (this.props.type === window.Enums.EBigCalenderType.CustomerBookedScheduler && this.props.mobileSize){
          return (
            <div style={{ fontSize: "12px", fontWeight: 500 }} className={classNames(this.HandleGetBoxProps())}>
              {__DayNamePart1 + " " + __DayNamePart2}
            </div>
          )
        }
        else if ((this.props.type ===window.Enums.EBigCalenderType.CustomerAvailableBookSelection_Individual || this.props.type ===  window.Enums.EBigCalenderType.CustomerAvailableBookSelection_Class) && this.props.mobileSize){
          return (
            <div style={{ fontSize: "12px", fontWeight: 500 }} className={classNames(this.HandleGetBoxProps())}>
              {__DayNamePart1 + " " + __DayNamePart2}
              <br />
              {__DayNamePart4}
            </div>
          )
        }
        else
        {
          return (
            <div className={classNames(this.HandleGetBoxProps())} style={{ fontWeight: 500 }}>
              {__DayNamePart1 + " " + __DayNamePart2}
              <br />
              {__DayNamePart4}
            </div>
          );
        }
      }

  }}, {} );

export default withStyles(BigCalendarStyles)(TBigCalenderDayHeader);
